export const usersEndpointConfig = {
  baseUrl: "api/v1/users",
  profileUrl: (): string => `${usersEndpointConfig.baseUrl}/profile`,
  activateAccountUrl: (email: string): string =>
    `${usersEndpointConfig.baseUrl}/${email}/activate`,
  contactForm: (userId: string) =>
    `${usersEndpointConfig.baseUrl}/${userId}/contact-request`,
  resendEmail: (email: string): string =>
    `${usersEndpointConfig.baseUrl}/${email}/resend-activation-email`,
  resetPassword: (email: string): string =>
    `${usersEndpointConfig.baseUrl}/${email}/reset-password`,
  resetPasswordConfirm: (email: string): string =>
    `${usersEndpointConfig.baseUrl}/${email}/reset-password/confirm`,
  marketingConsent: (userId: string, isEnabled: boolean): string =>
    `${usersEndpointConfig.baseUrl}/${userId}/consent/${isEnabled}`,
  confirmEmailChange: (): string =>
    `${usersEndpointConfig.baseUrl}/confirm-email-change`,
  getAllUsers: (): string => `${usersEndpointConfig.baseUrl}`,
  createUser: (): string => `${usersEndpointConfig.baseUrl}`,
  deleteUser: (userId: string): string =>
    `${usersEndpointConfig.baseUrl}/${userId}`,
  editUser: (userId: string): string =>
    `${usersEndpointConfig.baseUrl}/${userId}`,
  preferencesUrl: (): string => `${usersEndpointConfig.baseUrl}/preferences`,
  updateUserPreferences: (): string =>
    `${usersEndpointConfig.baseUrl}/preferences`,
};
